/**
 * Subscription Store
 * Manages subscription and membership data
 * 
 * @author Varun Pandey
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Subscription } from '@/api/types';

interface SubscriptionState {
  subscription: Subscription | null;
  availablePlans: any[];
  isLoading: boolean;
  error: string | null;
  
  // Actions
  setSubscription: (subscription: Subscription | null) => void;
  setAvailablePlans: (plans: any[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearSubscription: () => void;
}

export const useSubscriptionStore = create<SubscriptionState>()(
  persist(
    (set) => ({
      subscription: null,
      availablePlans: [],
      isLoading: false,
      error: null,

      setSubscription: (subscription) => set({ subscription }),

      setAvailablePlans: (plans) => set({ availablePlans: plans }),

      setLoading: (loading) => set({ isLoading: loading }),

      setError: (error) => set({ error }),

      clearSubscription: () => {
        set({
          subscription: null,
          availablePlans: [],
          error: null,
        });
      },
    }),
    {
      name: 'subscription-storage',
    }
  )
);
